/**
 * Shared card + field tokens for Company Edit Communications / Preferences tabs
 * (same shell as Angular company-edit “Resident paid” / property blocks).
 */
/** Same density as Communications “Resident paid” DaySelect (`h-10` / compact padding). */
export const COMM_FIELD_BASE =
    "min-h-10 rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-sm text-slate-800 shadow-sm transition focus:border-[rgb(21_151_255)] focus:outline-none focus:ring-2 focus:ring-[rgb(21_151_255)]/20 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500"

export const COMM_INNER_CARD =
    "w-full min-w-0 rounded-xl border border-slate-200/80 bg-gradient-to-b from-slate-50/50 to-white p-4 sm:p-5 sm:px-6 lg:px-8"

export const COMM_BLOCK_TITLE = "text-base font-semibold tracking-tight text-slate-800 sm:text-lg"

export const COMM_LABEL = "mb-1.5 flex items-center gap-1.5 text-sm font-medium text-slate-700"

/** One-column body under COMM_BLOCK_TITLE — same spacing as Communications resident-paid grid, without the second column. */
export const COMM_SINGLE_COLUMN_GRID =
    "mt-4 grid w-full min-w-0 grid-cols-1 gap-6 sm:mt-5 md:gap-6 lg:gap-10"
